import requests from './requests';

export default {
    captcha() {
        return requests
            .get('/sms_code/captcha')
            .then(resp => resp.data);
    },
    login(payload) {
        const { phone, captcha, captchaTag } = payload;
        return requests
            .post('/sms_code/login', {
                phone,
                captcha,
                captcha_tag: captchaTag,
            })
            .then(resp => resp.data);
    },
};



// WEBPACK FOOTER //
// ./src/api/sms_code.js